import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IErrorOnRequestState {
    isVisible: boolean;
    message: string;
}

const initialState: IErrorOnRequestState = {
    isVisible: false,
    message: "",
};

export const errorOnRequestSlice = createSlice({
    name: "errorOnRequest",
    initialState,
    reducers: {
        resetErrorOnRequest: () => initialState,
        setError: (state, action: PayloadAction<IErrorOnRequestState>) => {
            state.isVisible = action.payload.isVisible;
            state.message = action.payload.message;
        },
    },
});

export const { resetErrorOnRequest, setError } = errorOnRequestSlice.actions;

export default errorOnRequestSlice.reducer;
